module.exports = __webpack_public_path__ + "static/carpooling-app-mobile-plp-c0bcfd008deab0adc6b60427d32cae38.png";